/**
 * Generates initials from a name or label string.
 * 
 * Rules:
 * - Single word: Takes first 2 characters
 * - Multiple words: Takes first letter of first word + first letter of last word
 * - Always returns uppercase
 * - Max 2 characters
 * 
 * @param name - The name or label to generate initials from
 * @returns A 1-2 character uppercase string
 * 
 * @example
 * generateInitials('John Doe') // 'JD'
 * generateInitials('ShopExperts Agency') // 'SA'
 * generateInitials('Alice') // 'AL'
 * generateInitials('') // ''
 */
export function generateInitials(name: string): string {
    const cleaned = name.trim()
    if (cleaned.length === 0) return ''

    const words = cleaned.split(/\s+/)
    
    if (words.length === 1) {
        // Single word: take first 2 characters
        return words[0].substring(0, 2).toUpperCase()
    }
    
    return (words[0][0] + words[words.length - 1][0]).toUpperCase()
}

